import { render } from "./NavLink.vue?vue&type=template&id=23ce39ee"
import script from "./NavLink.vue?vue&type=script&lang=js"
export * from "./NavLink.vue?vue&type=script&lang=js"

import "./NavLink.vue?vue&type=style&index=0&id=23ce39ee&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__